module.exports = __webpack_public_path__ + "img/model_70_zh.2e5738be.png";